<span class="info-cell__title">{{ title }}</span>
<span class="info-cell__value">{{ value }}</span>
